import { render, staticRenderFns } from "./StageWarningModal.vue?vue&type=template&id=21d1ad02&"
import script from "./StageWarningModal.vue?vue&type=script&lang=js&"
export * from "./StageWarningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports